// format warranty to 99,999 pattern
export const warrantyFormatter = (warranty: string) => {
  return warranty ? warranty.replace(/\d{3}$/, "K") : warranty;
};
